import { Lookup } from '../models/lookup';
import { User } from '../models/user';
import { Coupon } from '../models/coupon';
import { AppComponent } from '../app.component';

export class Globals {
    public static appComponent: AppComponent;
    public static currentUser: User;
    public static lookup: Lookup;
    public static activeCoupon: Coupon;
}
